module.exports = __webpack_public_path__ + "Server-Default.AzureSubscription.eaf01f7a56607fd37388693bc75325ff.hashedasset.svg";